import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';

export const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  margin: 14px 0;

  .MuiOutlinedInput-root {
    width: 100%;
    margin: 0;
  }


  button.Mui-disabled {
    width: 75px;
  }

  button {
    margin: 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 75px;
    border-radius: 0 6px 6px 0;
  }
`;

export const Box = styled.div`
  border: 1px solid ${COLOR.GREY_3};
  border-radius: 6px;
  height: 204px;
  padding: 16px 18px;
  margin-bottom: 24px;

  /* Viewport <= 367px */
  @media screen and (max-width: 367px) {
    padding: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  button {
    width: 100%;
    max-width: 324px;
    margin: 14px auto;
    display: flex;
  }
`;

export const QRBox = styled.div`
  width: 100px;
  height: 100px;
  background-color: #C4C4C4;
`;

export const ReloadButton = styled.button`
  border: 0;
  cursor: pointer;
  background: none;
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 16px;
  color: ${(props) => (props.disabled ? COLOR.GREY_3 : COLOR.GREEN_1)};
  text-decoration: underline;

  & > svg {
    margin-left: 10px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  max-width: 300px;
  margin: 12px auto;
  justify-content: space-around;
  align-items: center;
`;
